import { Box, Tooltip, Typography, alpha, useTheme } from '@mui/material';
import { WEEKDAYS } from './team-activity.format';

export default function ActivityHeatmap({ values, hues, unit = 'min', compact = false, format = (v: number) => `${v} ${unit}` }: {
  values: number[];
  hues?: (string | null)[];
  unit?: string;
  compact?: boolean;
  format?: (v: number) => string;
}) {
  const theme = useTheme();
  const max = Math.max(1, ...values);
  const cell = compact ? 7 : undefined;
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: compact ? `repeat(24, ${cell}px)` : 'auto repeat(24, minmax(0, 1fr))', gap: compact ? '2px' : '3px', alignItems: 'center' }}>
      {!compact && <Box />}
      {!compact && Array.from({ length: 24 }, (_, h) => (
        <Typography key={h} variant="caption" color="text.secondary" sx={{ textAlign: 'center', fontSize: '0.65rem' }}>
          {h % 3 === 0 ? h : ''}
        </Typography>
      ))}
      {WEEKDAYS.map((day, d) => [
        !compact && (
          <Typography key={`l${d}`} variant="caption" color="text.secondary" sx={{ pr: 1, fontSize: '0.7rem' }}>{day}</Typography>
        ),
        ...Array.from({ length: 24 }, (_, h) => {
          const v = values[d * 24 + h] ?? 0;
          const hue = hues?.[d * 24 + h] ?? theme.palette.primary.main;
          const box = (
            <Box key={`${d}-${h}`} sx={{
              height: compact ? cell : 22, width: compact ? cell : 'auto', borderRadius: compact ? '1px' : 0.5,
              bgcolor: v ? alpha(hue, 0.18 + 0.82 * (v / max)) : theme.palette.action.hover,
            }} />
          );
          return compact ? box : (
            <Tooltip key={`${d}-${h}`} title={`${day} ${String(h).padStart(2, '0')}:00 — ${v ? format(v) : 'nothing'}`} disableInteractive>
              {box}
            </Tooltip>
          );
        }),
      ])}
    </Box>
  );
}
